<template>
  <div class="security-visible-dia">
    <el-dialog
      :title="dialogTitle"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="close"
    >
      <div v-if="tipExplain" style="margin-bottom: 20px;">
        <span style="color: #ff8695;font-size: 14px;">{{ tipExplain }}</span>
      </div>
      <div class="tip-centent">
        <span v-if="commandTipText">{{ commandTipText }}</span>
        <slot name="commandTipText" />
      </div>
      <div class="command">
        <div style="width: max-content">谷歌验证码：</div>
        <el-input
          v-model="command"
          placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="close">取消</el-button>
        <el-button
          type="primary"
          :loading="commandButLoading"
          @click.native="commandSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: String,
      default: "",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    commandButLoading: {
      type: Boolean,
      default: false,
    },
    tipExplain: {
      type: String,
      default: "",
    },
    commandTipText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      command: "",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    commandSure() {
      if (!this.command.trim()) {
        this.$message.error("请输入动态口令");
        return;
      }
      this.$emit("commandSure", this.command);
    },
  },
};
</script>

<style lang="scss" scoped ref="stylesheet/scss">
.security-visible-dia {
  .tip-centent {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
  .command {
    display: flex;
    align-items: center;
    /deep/.el-input {
      width: 300px;
    }
  }
}
</style>
